import { render } from "./DocumentationFormulasView.vue?vue&type=template&id=62ca06e4&scoped=true&ts=true"
import script from "./DocumentationFormulasView.vue?vue&type=script&lang=ts"
export * from "./DocumentationFormulasView.vue?vue&type=script&lang=ts"

import "./DocumentationFormulasView.vue?vue&type=style&index=0&id=62ca06e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ca06e4"]])

export default __exports__